export const COMMON_VEHICLES = {
  Toyota: ['Corolla', 'Yaris', 'Hilux', 'RAV4', 'Fortuner', 'Land Cruiser', 'Prado', 'Tacoma', '4Runner', 'Rush', 'Raize'],
  Honda: ['Civic', 'Accord', 'CR-V', 'HR-V', 'Pilot', 'Fit', 'City', 'Odyssey'],
  Nissan: ['Sentra', 'Versa', 'Kicks', 'X-Trail', 'Frontier', 'Pathfinder', 'Navara', 'Qashqai'],
  Mazda: ['Mazda 2', 'Mazda 3', 'Mazda 6', 'CX-3', 'CX-5', 'CX-30', 'CX-50', 'BT-50'],
  Kia: ['Picanto', 'Rio', 'Cerato', 'Forte', 'Sportage', 'Sorento', 'Seltos', 'Soul', 'Carnival'],
  Hyundai: ['Accent', 'Elantra', 'Sonata', 'Tucson', 'Santa Fe', 'Creta', 'Venue', 'H-1'],
  Mitsubishi: ['Lancer', 'Mirage', 'Outlander', 'Montero Sport', 'L200', 'Eclipse Cross', 'ASX'],
  Chevrolet: ['Spark', 'Aveo', 'Onix', 'Tracker', 'Trax', 'Equinox', 'Colorado', 'Tahoe'],
  Ford: ['Fiesta', 'Focus', 'Escape', 'Explorer', 'Ranger', 'F-150', 'Edge', 'Bronco'],
  Volkswagen: ['Gol', 'Polo', 'Jetta', 'Golf', 'Tiguan', 'T-Cross', 'Amarok', 'Taos'],
  Suzuki: ['Swift', 'Celerio', 'Dzire', 'Vitara', 'S-Cross', 'Jimny', 'Ertiga'],
  Isuzu: ['D-Max', 'MU-X'],
  Jeep: ['Wrangler', 'Cherokee', 'Grand Cherokee', 'Compass', 'Renegade'],
  BMW: ['Serie 1', 'Serie 3', 'Serie 5', 'X1', 'X3', 'X5'],
  'Mercedes-Benz': ['Clase A', 'Clase C', 'Clase E', 'GLA', 'GLC', 'GLE', 'Sprinter'],
}

export const COMMON_COLORS = ['Blanco', 'Negro', 'Gris', 'Plata', 'Rojo', 'Azul', 'Verde', 'Beige', 'Café', 'Dorado', 'Amarillo', 'Naranja', 'Morado', 'Vino', 'Turquesa']

const fold = (value = '') => value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

function distance(left, right) {
  const a = fold(left)
  const b = fold(right)
  const row = Array.from({ length: b.length + 1 }, (_, index) => index)
  for (let i = 1; i <= a.length; i += 1) {
    let previous = row[0]
    row[0] = i
    for (let j = 1; j <= b.length; j += 1) {
      const saved = row[j]
      row[j] = Math.min(row[j] + 1, row[j - 1] + 1, previous + (a[i - 1] === b[j - 1] ? 0 : 1))
      previous = saved
    }
  }
  return row[b.length]
}

function closest(value, options) {
  if (!value?.trim()) return null
  const ranked = options.map((option) => ({ option, distance: distance(value, option) })).sort((a, b) => a.distance - b.distance)
  const maximum = fold(value).length >= 6 ? 2 : 1
  return ranked[0]?.distance <= maximum ? ranked[0].option : null
}

export function correctVehicleIdentity(make, model) {
  const brands = Object.keys(COMMON_VEHICLES)
  const modelAsBrand = closest(model, brands)
  const makeAsModels = Object.entries(COMMON_VEHICLES).flatMap(([brand, models]) => models.map((name) => ({ brand, model: name, distance: distance(make, name) }))).sort((a, b) => a.distance - b.distance)
  const makeAsModel = makeAsModels.find((item) => item.brand === modelAsBrand && item.distance <= (fold(make).length >= 6 ? 2 : 1))
  if (modelAsBrand && makeAsModel) return { make: modelAsBrand, model: makeAsModel.model, corrected: true }

  const resolvedMake = closest(make, brands) || make.trim()
  const resolvedModel = closest(model, COMMON_VEHICLES[resolvedMake] || []) || model.trim()
  return { make: resolvedMake, model: resolvedModel, corrected: resolvedMake !== make.trim() || resolvedModel !== model.trim() }
}

export function vehicleModelsFor(make) {
  const brand = closest(make, Object.keys(COMMON_VEHICLES))
  return brand ? COMMON_VEHICLES[brand] : Object.values(COMMON_VEHICLES).flat()
}

export function normalizePlate(value) {
  const raw = String(value || '').toUpperCase().trim()
  const compact = raw.replace(/[^A-Z0-9]/g, '')
  const hasPrefix = /^P(?:[\s-]|$)/.test(raw) || (compact.startsWith('P') && compact.length === 7)
  const payload = hasPrefix ? compact.slice(1) : compact
  const digits = payload.replace(/\D/g, '').slice(0, 3)
  const letters = payload.replace(/[^A-Z]/g, '').slice(0, 3)
  return `P-${digits}${letters}`
}

export function isCompletePlate(value) {
  return /^P-\d{3}[A-Z]{3}$/.test(normalizePlate(value))
}
